import React, { useState, useEffect } from 'react';
import DataTable from '../../components/DataTable';
import TrialBalance from '../../components/TrialBalance';
import { journalEntriesAPI } from '../../lib/api';

const JournalEntries = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchEntries = async () => {
    setLoading(true);
    try {
      const response = await journalEntriesAPI.getAll();
      setEntries(response.data);
    } catch (error) {
      console.error('Error fetching entries:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  const columns = [
    { key: 'date', label: 'Date', type: 'date' },
    { key: 'description', label: 'Description' },
    { key: 'reference', label: 'Reference' },
    { key: 'status', label: 'Status', type: 'status' },
  ];

  const formFields = [
    { name: 'date', label: 'Date', type: 'date', required: true },
    { name: 'description', label: 'Description', required: true, placeholder: 'Entry description' },
    { name: 'reference', label: 'Reference', placeholder: 'Reference number' },
    {
      name: 'status',
      label: 'Status',
      type: 'select',
      defaultValue: 'draft',
      options: [
        { value: 'draft', label: 'Draft' },
        { value: 'posted', label: 'Posted' },
        { value: 'void', label: 'Void' },
      ],
    },
  ];

  const handleAdd = async (data) => {
    await journalEntriesAPI.create(data);
    fetchEntries();
  };

  const handleEdit = async (id, data) => {
    await journalEntriesAPI.update(id, data);
    fetchEntries();
  };

  const handleDelete = async (id) => {
    await journalEntriesAPI.delete(id);
    fetchEntries();
  };

  return (
    <>
    <DataTable
      title="Journal Entries"
      description="Record accounting entries"
      data={entries}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
      searchField="description"
    />
    <TrialBalance />
    </>
  );
};

export default JournalEntries;
